import _ from 'lodash'

import {
    CONTRACTS_LOAD_PARTICIPANTS,
    CONTRACTS_LOAD_PARTICIPANTS_REQUEST,
    CONTRACTS_PARTICIPANTS_DATA_RECEIVED,
    CONTRACTS_PARTICIPANTS_LOADING_TRUE,
    CONTRACTS_PARTICIPANTS_LOADING_FALSE,
} from './constants'

import config from '../../../../../../../../../../../../../config'

export function contractsLoadDocParticipants(module, blockKey, entId, level, docId, customData) {
    return {
        type: CONTRACTS_LOAD_PARTICIPANTS,
        data: {
            module,
            blockKey,
            entId,
            level,
            docId,
            customData,
        },
    }
}

export function contractsLoadDocParticipantsRequest(module, blockKey, entId, docId, level, lang, token, queryParams) {
    return {
        type: CONTRACTS_LOAD_PARTICIPANTS_REQUEST(entId, docId),
        payload: {
            ..._.get(config, `api.${module}.${blockKey}.participants`),
            qs: {
                ...queryParams,
                lang,
                token,
                level,
            },
            uriParams: {
                entId,
                docId,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function contractsDocParticipantsLoadingTrue(module, blockKey, id, customData) {
    return {
        type: CONTRACTS_PARTICIPANTS_LOADING_TRUE,
        data: {
            module,
            blockKey,
            id,
            customData,
        },
    }
}

export function contractsDocParticipantsLoadingFalse(module, blockKey, id, customData) {
    return {
        type: CONTRACTS_PARTICIPANTS_LOADING_FALSE,
        data: {
            module,
            blockKey,
            id,
            customData,
        },
    }
}

export function contractsDocParticipantsDataReceived(module, blockKey, id, customData) {
    return {
        type: CONTRACTS_PARTICIPANTS_DATA_RECEIVED,
        data: {
            module,
            blockKey,
            id,
            customData,
        },
    }
}
